<template>
    <v-card flat>
      <v-card-text>
        <v-row>
          <v-text-field
            v-model="company"
            :label="$t('contacts.columns.company')"
          ></v-text-field>
        </v-row>
        <v-row>
          <v-text-field
            v-model="jobTitle"
            :label="$t('contacts.columns.jobTitle')"
          ></v-text-field>
        </v-row>
      </v-card-text>
    </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'contacts-form-fields-companyTab',
  computed: {
    ...mapGetters({
      contact: 'contacts/form/contact'
    }),
    company: { get () { return this.contact?.company }, set (company) { this.setCompany(company) } },
    jobTitle: { get () { return this.contact?.jobTitle }, set (jobTitle) { this.setJobTitle(jobTitle) } }
  },
  methods: {
    ...mapActions({
      setCompany: 'contacts/form/setCompany',
      setJobTitle: 'contacts/form/setJobTitle'
    })
  }
}
</script>

<style>

</style>
